module.exports = __webpack_public_path__ + "static/avril-excited-fee9539bf4170eff8d92057e710ee14a.gif";